import React,{useEffect} from 'react';
import Cover from "../../assets/contact/cover.png"
import MbCover from "../../assets/contact/mbcover.png"
import Logo from "../../assets/home/logo.png"
import Facebook from "../../assets/home/facebook.png"
import Instagram from "../../assets/home/instagram.png"
import ThreeWave from "../../assets/home/three_wave.png"
import FacebookIcon from "../../assets/home/facebook-icon.png"
import InstagramIcon from "../../assets/home/instagram-icon.png"
import Img1 from "../../assets/contact/img.png"
import Img2 from "../../assets/contact/img2.png"
import Arrow from "../../assets/teach/arrow.png"
import Menu from "../../assets/home/menu.png"

import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./contact.css"
import X from "../../assets/home/x.png"
import Sun from "../../assets/home/sun.png"
// import component 👇
import Drawer from 'react-modern-drawer'
import BlackSun from "../../assets/home/sun-black.png"
import BlueSun from "../../assets/home/sun-blue.png"
import SunBg from "../../assets/home/sunbg.png"
import WhiteWave from "../../assets/home/wave-white.png"
//import styles 👇
import 'react-modern-drawer/dist/index.css'
import Seo from "../../components/seo"
import { getTideData } from "../../utils/tide"
function Contact() {
  const { t, i18n } = useTranslation();
  const navigation = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false)
  const [isOpenSide, setIsOpenSide] = React.useState(false)
  const [isOpenSideMb, setIsOpenSideMb] = React.useState(false)
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState)
  }
  const toggleDrawerSide = () => {
    setIsOpenSide((prevState) => !prevState)
  }
  const toggleDrawerSideMb = () => {
    setIsOpenSideMb((prevState) => !prevState)
  }
  const [tideData] = React.useState(() => getTideData(new Date()))
  const [weatherData, setWeatherData] = React.useState({
    airTemp: 26,
    seaTemp: 28,
    windSpeed: 5,
    windDirection: "西北",
    waveHeight: 0.5
  })
  const getWindDirection = (degrees: number) => {
    const directions = ["北", "東北", "東", "東南", "南", "西南", "西", "西北"];
    return directions[Math.round(degrees / 45) % 8];
  }
  useEffect(() => {
    window.scrollTo(0, 0);
 }, []);
  useEffect(() => {
    const fetchSeaConditions = async () => {
      try {
        const response = await fetch(
          'https://marine-api.open-meteo.com/v1/marine?latitude=24.8607&longitude=121.8367&hourly=sea_surface_temperature,wave_height&timezone=Asia%2FTaipei&forecast_days=1'
        );
        const data = await response.json();
        const times: string[] = data.hourly.time;
        const seaTemps: number[] = data.hourly.sea_surface_temperature;
        const waveHeights: number[] = data.hourly.wave_height;
        const today = times[0].slice(0, 10);
        const currentHour = (new Date().getUTCHours() + 8) % 24;
        const hourIndex = times.indexOf(`${today}T${String(currentHour).padStart(2, '0')}:00`);
        if (hourIndex >= 0) {
          setWeatherData((prev) => ({
            ...prev,
            seaTemp: Math.round(seaTemps[hourIndex]),
            waveHeight: waveHeights[hourIndex]
          }));
        }
      } catch (error) {
        // keep fallback sea temperature/wave height
      }
    };
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          'https://api.open-meteo.com/v1/forecast?latitude=24.8607&longitude=121.8367&current=temperature_2m,wind_speed_10m,wind_direction_10m&wind_speed_unit=ms&timezone=Asia%2FTaipei'
        );
        const data = await response.json();
        setWeatherData((prev) => ({
          ...prev,
          airTemp: Math.round(data.current.temperature_2m),
          windSpeed: Math.round(data.current.wind_speed_10m),
          windDirection: getWindDirection(data.current.wind_direction_10m)
        }));
      } catch (error) {
        // keep fallback air temperature/wind data
      }
    };
    fetchSeaConditions();
    fetchWeather();
  }, []);
  return (
    <div>
    <Seo title={t("seoContactTitle")} description={t("seoContactDescription")} path="/contact" />
    <div className='contact_web'>
    <button style={{display:"flex",position:"fixed",right:24,bottom:24,width:64,height:64,border:"none",backgroundColor:"white",boxShadow:"0px 4px 24px 0px rgba(12, 11, 11, 0.12)",borderRadius:16,justifyContent:"center",alignItems:"center"}} onClick={()=>{
        setIsOpenSide(true)
      }}>
      <img src={BlackSun} style={{ width: 32, height: 32 }} alt="" />

      </button>
      <div style={{ position: "fixed", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", paddingTop: 20 }}>
        <Link to="/home" style={{ marginLeft: 50 }}>
          <img src={Logo} style={{ width: 80, height: 80 }} alt="藍洋衝浪 Blue Ocean Surf" />
        </Link>
        <div style={{ marginRight: 50, display: "flex", alignItems: "center" }}>
          <Link to="/teach" style={{ fontWeight: "bold", fontSize: 16, marginRight: 50, fontFamily: "Noto Sans TC", color: "#0C0B0B", textDecoration: "none" }}>{t("surfTeaching")}</Link>
          <span style={{ fontWeight: "bold", fontSize: 16, marginRight: 50, fontFamily: "Noto Sans TC", color: "#0C0B0B" }}>{t("contact")}</span>
          <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 50 }}>
            <img src={Facebook} style={{ width: 24, height: 24 }} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 50 }}>
            <img src={Instagram} style={{ width: 24, height: 24 }} alt="Instagram" />
          </a>
          <button style={{ background: "none", border: "none", fontWeight: "bold", fontSize: 16, fontFamily: "Noto Sans TC",color:"#0C0B0B" }} onClick={() => {
            if (i18n.language === "tw") {
              i18n.changeLanguage("en")
            } else {
              i18n.changeLanguage("tw")
            }
          }}>中 / 英</button>
        </div>
      </div>
      <div style={{ backgroundImage: `url(${Cover})`, width: "100%", height: 560, backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <h1 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("contact")}</h1>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <div style={{ display: "flex", alignItems: "center",marginTop:32 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24}}>{t("open")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>07:00 - 19:00</p>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24 }}>{t("storePhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>+886 3 978 9233</p>
        </div>
        <div style={{ display: "flex", alignItems: "center"}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24 }}>{t("bookingPhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>+886 928 378 138</p>
        </div>
        <div style={{ display: "flex", alignItems: "center"}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24 }}>{t("email")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>chehow_0906@hotmail.com</p>
        </div>
        <div style={{display:"flex",justifyContent:"center",marginTop:80,marginBottom:120}}>
          <div style={{display:"flex",flexDirection:"column",marginRight:64}}>
          <img src={Img1} style={{ width: 472, height: 320 }} alt={t("firstStore")} />
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("firstStore")}</p>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("firstStoreAddress")}</p>
            <a href="https://maps.google.com/?q=宜蘭縣頭城鎮濱海路一段385-1號" target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF",marginRight:10}}>{t("go")}</p>
            <img src={Arrow} style={{ width: 24, height: 24,marginRight:24 }} alt="" />
            </a>
          </div>
          <div style={{display:"flex",flexDirection:"column"}}>
          <img src={Img2} style={{ width: 472, height: 320 }} alt={t("secondStore")} />
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("secondStore")}</p>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("secondStoreAddress")}</p>
            <a href="https://maps.app.goo.gl/2ZYFaAoEshXA6vQf6" target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF",marginRight:10}}>{t("go")}</p>
            <img src={Arrow} style={{ width: 24, height: 24,marginRight:24 }} alt="" />
            </a>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", backgroundColor: "black",paddingTop:64,paddingBottom:24 }}>
        <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginLeft:112 }}>{t("blueOcean")}</p>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("open")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>07:00 - 19:00</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("storePhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 3 978 9233</p>
        </div>
        <div style={{ display: "flex", alignItems: "center" ,marginLeft:112}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("bookingPhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 928 378 138</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("email")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>chehow_0906@hotmail.com</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("address")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("addressRoad")}</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 15,marginLeft:112 }}>
          <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 24 }}>
            <img src={FacebookIcon} style={{ width: 20, height: 20 }} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer">
            <img src={InstagramIcon} style={{ width: 20, height: 20 }} alt="Instagram" />
          </a>
        </div>
        <div style={{width:"85%",height:1,backgroundColor:"#404040",margin:"auto",marginTop:64}}></div>
        <p style={{ fontWeight: "600", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F",textAlign:"center",marginTop:24 }}>© 2026藍洋衝浪店Blue Ocean Surf Shop</p>
      </div>
    </div>
    <div className='contact_phone'>
    <div style={{ position: "fixed", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
        <Link to="/home">
          <img src={Logo} style={{ width: 48, height: 48,marginTop:24,marginLeft:24 }} alt="藍洋衝浪 Blue Ocean Surf" />
        </Link>
        <img src={Menu} style={{ width: 24, height: 24, marginTop:24,marginRight:24}} alt=""  onClick={() => {
            setIsOpen(true)
          }}/>        
      </div>
      <div style={{ backgroundImage: `url(${MbCover})`, width: "100%", height: 400, backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <h1 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", marginTop: 80 }}>{t("contact")}</h1>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <div style={{ display: "flex", alignItems: "center",marginTop:32 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24}}>{t("open")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>07:00 - 19:00</p>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24 }}>{t("storePhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>+886 3 978 9233</p>
        </div>
        <div style={{ display: "flex", alignItems: "center"}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24 }}>{t("bookingPhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>+886 928 378 138</p>
        </div>
        <div style={{ display: "flex", alignItems: "center"}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginRight: 24 }}>{t("email")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>chehow_0906@hotmail.com</p>
        </div>
        <div style={{display:"flex",justifyContent:"center",marginTop:50,marginBottom:120,flexDirection:"column",alignItems:"center",width:"100%"}}>
          <div style={{display:"flex",flexDirection:"column",width:"85%"}}>
          <img src={Img1} style={{ width: "100%" }} alt={t("firstStore")} />
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("firstStore")}</p>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("firstStoreAddress")}</p>
            <a href="https://maps.google.com/?q=宜蘭縣頭城鎮濱海路一段385-1號" target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF",marginRight:10}}>{t("go")}</p>
            <img src={Arrow} style={{ width: 24, height: 24,marginRight:24 }} alt="" />
            </a>
          </div>
          <div style={{display:"flex",flexDirection:"column",marginTop:30,width:"85%"}}>
          <img src={Img2} style={{ width: "100%" }} alt={t("secondStore")} />
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("secondStore")}</p>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040"}}>{t("secondStoreAddress")}</p>
            <a href="https://maps.app.goo.gl/2ZYFaAoEshXA6vQf6" target="_blank" rel="noopener noreferrer" style={{display:"flex",alignItems:"center",textDecoration:"none"}}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF",marginRight:10}}>{t("go")}</p>
            <img src={Arrow} style={{ width: 24, height: 24,marginRight:24 }} alt="" />
            </a>
          </div>
        </div>
      </div>

      <div style={{ width: "100%", backgroundColor: "black",paddingTop:64,paddingBottom:24 }}>
        <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginLeft:24 }}>{t("blueOcean")}</p>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("open")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>07:00 - 19:00</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("storePhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 3 978 9233</p>
        </div>
        <div style={{ display: "flex", alignItems: "center" ,marginLeft:24}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("bookingPhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 928 378 138</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("email")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>chehow_0906@hotmail.com</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("address")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("addressRoad")}</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 15,marginLeft:24 }}>
          <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 24 }}>
            <img src={FacebookIcon} style={{ width: 20, height: 20 }} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer">
            <img src={InstagramIcon} style={{ width: 20, height: 20 }} alt="Instagram" />
          </a>
        </div>
        <div style={{width:"85%",height:1,backgroundColor:"#404040",margin:"auto",marginTop:64}}></div>
        <p style={{ fontWeight: "600", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F",textAlign:"center",marginTop:24 }}>© 2026藍洋衝浪店Blue Ocean Surf Shop</p>
      </div>
    </div>
    <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction='right'
        className='bla bla bla'
        size={"100%"}
      >
        <div style={{ backgroundColor: "#0C0B0B", height: "100vh", display: "flex",flexDirection:"column" }}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", height: 80, alignItems: "center" }}>
            <img src={Logo} style={{ width: 48, height: 48, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf"  onClick={() => {
              navigation("/home")
              setIsOpen(false)

            }}/>
            <img src={X} style={{ width: 24, height: 24, marginRight: 24 }} alt="" onClick={() => {
              setIsOpen(false)
            }} />
          </div>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              navigation("/teach")
              setIsOpen(false)

            }}>
            <p style={{fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white"}}>{t("surfTeaching")}</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              navigation("/contact")
              setIsOpen(false)

            }}>
            <p style={{fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginTop:40}}>{t("contact")}</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
                        window.open("https://www.facebook.com/BlueOceanSurfShop/");

              setIsOpen(false)
            }}>
          <img src={FacebookIcon} style={{ width: 24, height: 24,marginTop:40 }} alt="Facebook" />
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
             window.open("https://www.instagram.com/blueoceansurftaiwan/");
              setIsOpen(false)
            }}>
          <img src={InstagramIcon} style={{ width: 24, height: 24,marginTop:40 }} alt="Instagram" />
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}}onClick={() => {
            if (i18n.language === "tw") {
              i18n.changeLanguage("en")
            } else {
              i18n.changeLanguage("tw")
            }
              setIsOpen(false)
            }}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "white",marginTop:40}}>中 / ＥＮ</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              setIsOpen(false)
            }}>
          <img src={Sun} style={{ width: 24, height: 24,marginTop:40 }} alt=""  onClick={()=>{
            setIsOpenSideMb(true)
          }}/>
          </button>
        </div>
      </Drawer>
      <Drawer
        open={isOpenSide}
        onClose={toggleDrawerSide}
        direction='right'
        className='bla bla bla'
        size={112}
      >
        <div style={{ height: "100vh", display: "flex",flexDirection:"column",boxShadow:"-4px 0px 16px 0px rgba(12, 11, 11, 0.12);",alignItems:"center" }}>
        <img src={BlueSun} style={{ width: 32, height: 32,marginTop:40 }} alt="" />
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.airTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>大氣</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.seaTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>海水</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windSpeed}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>風速</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.waveHeight}m</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>浪高</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windDirection}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>風向</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.lowTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.lowTides[1]}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>乾潮</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.highTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.highTides[1]}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>滿潮</p>
            </div>
        <img src={X} style={{ width: 32, height: 32,marginTop:40 }} alt="" onClick={()=>{
          setIsOpenSide(false)
        }}/>

        </div>
      </Drawer>
      <Drawer
        open={isOpenSideMb}
        onClose={toggleDrawerSideMb}
        direction='right'
        className='bla bla bla'
        size={"100%"}
      >
        <div style={{ backgroundImage: `url(${SunBg})`, height: "100vh", display: "flex",flexDirection:"column", backgroundSize: "cover" ,alignItems:"center"}}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", height: 80, alignItems: "center" }}>
            <img src={Logo} style={{ width: 48, height: 48, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf"  onClick={() => {
              navigation("/home")
              setIsOpenSideMb(false)

            }}/>
            <img src={X} style={{ width: 24, height: 24, marginRight: 24 }} alt="" onClick={() => {
              setIsOpenSideMb(false)
            }} />
          </div>
          <img src={BlueSun} style={{ width: 56, height: 56,marginTop:40 }} alt="" />
          <div style={{display:"flex",justifyContent:"space-between",width:"40%",marginTop:30}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.airTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("air")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.seaTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("sea")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

          <div style={{display:"flex",justifyContent:"space-between",width:"70%"}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windSpeed}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windSpeed")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.waveHeight}m</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("waveHeight")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windDirection}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windDirection")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

          <div style={{display:"flex",justifyContent:"space-between",width:"40%"}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
          <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.lowTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.lowTides[1]}</p>
            <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("lowTide")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.highTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.highTides[1]}</p>
            <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("highTide")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />
          
        </div>
      </Drawer>
    </div>
  );
}

export default Contact;
